module.exports = __webpack_public_path__ + "static/amelie_1-de3295c460faba281db65aaf613fd4a2.jpg";